import React, {Component} from 'react'
import {connect} from 'react-redux'
import {getTitle} from "../fncomponents/PageTitleUtils";
import {Helmet} from "react-helmet/es/Helmet";
import {confirmTransfer, confirmWithdrawal} from "../../redux/actions/wallet";

const qs = require("query-string")


class ConfirmTransfer extends Component {

    componentDidMount() {
        let token = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).ttkdjf
        this.props.confirmTransfer(token)
    }

    render() {
        return (
            <div className={'loginForm'} style={{marginTop: "6em", width: "20rem", textAlign: "center"}}>
                {!this.props.user && <h3>Confirm Transfer</h3>}
                <Helmet>
                    <title>{getTitle()}</title>
                </Helmet>
            {this.props.transferConfirmSuccess && <div>
                <div>Your transfer has been confirmed.</div>
            </div>}
            {Object.keys(this.props.errors).length > 0 && <div>
                <div>We apologise, but token seems missing or expired...</div>
            </div>}
            </div>)
    }
}

const mapStateToProps = rootState => ({
    transferConfirmSuccess: rootState.wallet.transferConfirmSuccess,
    errors: rootState.errors,
    user: rootState.authentication.user,
})

const mapDispatchToProps = dispatch => {
    return {
        confirmTransfer: (props) => dispatch(confirmTransfer(props)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps) (ConfirmTransfer)
